import { useSesi } from './state';
import { Masuk } from './screens/Masuk';
import { BukaShift } from './screens/BukaShift';
import { Kasir } from './screens/Kasir';

export function App() {
  const { sesi, siap, penyimpananOk } = useSesi();

  if (!siap) {
    return <div className="tengah"><div className="putar" /></div>;
  }

  // Kasir yang tidak bisa menyimpan lokal berarti kasir yang kehilangan
  // pesanan saat internet putus. Lebih baik dihentikan di sini, sebelum
  // shift dimulai, daripada baru ketahuan saat ada 40 pesanan hilang.
  if (!penyimpananOk) {
    return (
      <div className="tengah">
        <div className="kartu">
          <h1>Penyimpanan tidak bisa dipakai</h1>
          <p className="ket">
            Aplikasi ini menyimpan pesanan di perangkat supaya tetap bisa bekerja
            saat internet mati. Di perangkat ini penyimpanan terblokir, jadi
            pesanan berisiko hilang.
          </p>
          <div className="galat">
            Biasanya karena browser dibuka dalam mode penyamaran, atau data situs
            diblokir. Buka di jendela biasa, lalu izinkan penyimpanan untuk situs ini.
          </div>
        </div>
      </div>
    );
  }

  if (!sesi) return <Masuk />;
  if (!sesi.shiftId) return <BukaShift />;
  return <Kasir />;
}
